// extracted by mini-css-extract-plugin
export default {"root":"Cmxf5QIGLXZT1V2DQG2s","placeHolderShimmer":"WjgyOOM1BNJa_jmYUu2z"};